<template>
    <focus-lock
        :disabled="!showModal"
        :class="{ 'cz3__modal-focus-lock': showModal }"
        group="modal"
    >
        <slot />
    </focus-lock>
</template>

<script>
    import { mapStores } from 'pinia';
    import FocusLock from 'vue-focus-lock';
    import { useAppStore } from '../stores/app';

    export default {
        name: 'BaseModalFocusLock',

        components: {
            FocusLock,
        },

        props: {
            showModal: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                hasRegisteredOpenModal: false,
            };
        },

        computed: {
            ...mapStores(useAppStore),
        },

        watch: {
            showModal: {
                immediate: true,
                handler(showModal) {
                    this.syncOpenModalState(showModal);
                },
            },
        },

        beforeUnmount() {
            this.unregisterOpenModal();
        },

        methods: {
            syncOpenModalState(showModal) {
                if (showModal) {
                    this.registerOpenModal();
                    return;
                }

                this.unregisterOpenModal();
            },

            registerOpenModal() {
                if (this.hasRegisteredOpenModal) {
                    return;
                }

                this.appStore.registerOpenModal();
                this.hasRegisteredOpenModal = true;
            },

            unregisterOpenModal() {
                if (!this.hasRegisteredOpenModal) {
                    return;
                }

                this.appStore.unregisterOpenModal();
                this.hasRegisteredOpenModal = false;
            },
        },
    };
</script>

<style>
    #cz3 .cz3__modal-focus-lock {
        position: fixed;
        inset: 0;
        z-index: 100;
        overflow: hidden;
    }

    #cz3 .cz3__modal-focus-lock > [data-lock] {
        height: 100%;
    }
</style>
